<script>
	import Gallery from './Gallery.svelte';
	import Modal from './Modal.svelte';

	let showModal = false;
	let modalImage;

	function handleClick(e) {
		modalImage  = e.detail.src;
		modalImage  = modalImage.replaceAll("_thumb.jpg",".png");
		showModal   = true;
	}
</script>

<main>
{#if showModal}
	<Modal on:close="{() => showModal = false}">
    <img src="{modalImage}" alt="Full size" width="600" height="400"/><br>
	<input type="text" value={modalImage} size="70" readonly/><br>
	All art is are available with a <a href="http://creativecommons.org/licenses/by-sa/4.0/">Creative Commons Attribution-ShareAlike 4.0 International License</a>.
	(c) <a href="https://twitter.com/hochstenbach">@hochstenbach</a> 2021
    </Modal>
{:else}
    <div id="cy" style="display: none"></div>
{/if}

	<h1>Solvember</h1>
	<h4>@hochstenbach</h4>
	<p>30 days of cartoon sketches about Solid and the Decentralized Web</p>
	<Gallery gap={15} maxColumnWidth={250} on:click={handleClick}>
		<img src="https://pod.inrupt.com/hochstenbach/public/solvember/solvember_01_thumb.jpg" alt="1" />
		<img src="https://pod.inrupt.com/hochstenbach/public/solvember/solvember_02_thumb.jpg" alt="2" />
		<img src="https://pod.inrupt.com/hochstenbach/public/solvember/solvember_03_thumb.jpg" alt="3" />
		<img src="https://pod.inrupt.com/hochstenbach/public/solvember/solvember_04_thumb.jpg" alt="4" />
		<img src="https://pod.inrupt.com/hochstenbach/public/solvember/solvember_05_thumb.jpg" alt="5" />
		<img src="https://pod.inrupt.com/hochstenbach/public/solvember/solvember_06_thumb.jpg" alt="6" />
		<img src="https://pod.inrupt.com/hochstenbach/public/solvember/solvember_07_thumb.jpg" alt="7" />
		<img src="https://pod.inrupt.com/hochstenbach/public/solvember/solvember_08_thumb.jpg" alt="8" />
		<img src="https://pod.inrupt.com/hochstenbach/public/solvember/solvember_09_thumb.jpg" alt="9" />
		<img src="https://pod.inrupt.com/hochstenbach/public/solvember/solvember_10_thumb.jpg" alt="10" />
		<img src="https://pod.inrupt.com/hochstenbach/public/solvember/solvember_11_thumb.jpg" alt="11" />
		<img src="https://pod.inrupt.com/hochstenbach/public/solvember/solvember_12_thumb.jpg" alt="12" />
		<img src="https://pod.inrupt.com/hochstenbach/public/solvember/solvember_13_thumb.jpg" alt="13" />
		<img src="https://pod.inrupt.com/hochstenbach/public/solvember/solvember_14_thumb.jpg" alt="14" />
		<img src="https://pod.inrupt.com/hochstenbach/public/solvember/solvember_15_thumb.jpg" alt="15" />
		<img src="https://pod.inrupt.com/hochstenbach/public/solvember/solvember_16_thumb.jpg" alt="16" />
		<img src="https://pod.inrupt.com/hochstenbach/public/solvember/solvember_17_thumb.jpg" alt="17" />
		<img src="https://pod.inrupt.com/hochstenbach/public/solvember/solvember_18_thumb.jpg" alt="18" />
		<img src="https://pod.inrupt.com/hochstenbach/public/solvember/solvember_19_thumb.jpg" alt="19" />
		<img src="https://pod.inrupt.com/hochstenbach/public/solvember/solvember_20_thumb.jpg" alt="20" />
		<img src="https://pod.inrupt.com/hochstenbach/public/solvember/solvember_21_thumb.jpg" alt="21" />
		<img src="https://pod.inrupt.com/hochstenbach/public/solvember/solvember_22_thumb.jpg" alt="22" />
		<img src="https://pod.inrupt.com/hochstenbach/public/solvember/solvember_23_thumb.jpg" alt="23" />
		<img src="https://pod.inrupt.com/hochstenbach/public/solvember/solvember_24_thumb.jpg" alt="24" />
		<img src="https://pod.inrupt.com/hochstenbach/public/solvember/solvember_25_thumb.jpg" alt="25" />
		<img src="https://pod.inrupt.com/hochstenbach/public/solvember/solvember_26_thumb.jpg" alt="26" />
		<img src="https://pod.inrupt.com/hochstenbach/public/solvember/solvember_27_thumb.jpg" alt="27" />
		<img src="https://pod.inrupt.com/hochstenbach/public/solvember/solvember_28_thumb.jpg" alt="28" />
		<img src="https://pod.inrupt.com/hochstenbach/public/solvember/solvember_29_thumb.jpg" alt="29" />
		<img src="https://pod.inrupt.com/hochstenbach/public/solvember/solvember_30_thumb.jpg" alt="30" />
	</Gallery>
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		color: #8a308a;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>